import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export const api = {
  dashboard: () => axios.get(`${API}/api/dashboard`).then(r => r.data),
  cases: (params = {}) => axios.get(`${API}/api/cases`, { params }).then(r => r.data),
  createCase: (data) => axios.post(`${API}/api/cases`, data).then(r => r.data),
  caseById: (id) => axios.get(`${API}/api/cases/${id}`).then(r => r.data),
  updateCase: (id, fields) => axios.patch(`${API}/api/cases/${id}`, fields).then(r => r.data),
  requestDocument: (id, document) => axios.post(`${BASE}/cases/${id}/request-document`, { document }, { headers: authHeader() }),
  updateStatus: (id, status, note) => axios.patch(`${API}/api/cases/${id}/status`, { status, note }).then(r => r.data),
  sendMessage: (id, message) => axios.post(`${API}/api/cases/${id}/message`, { message }).then(r => r.data),
};
